module.exports = __webpack_public_path__ + "static/media/29BDOS10.2749163c.jpg";